const Vue = require('vue')
const Router = require('vue-router')
const Layout = () => import('@/components/layout/index.vue')
const Login = () => import('@/page/login/login.vue')
const Home = () => import('@/page/home')
const Error404 = () => import('@/page/404.vue')
const Notice = () => import('@/page/notice.vue')
const BaseInfo = () => import('@/page/base_info.vue')
const FeedbackResults = () => import('@/page/feedback_results.vue')
const ChangePassWord = () => import('@/page/changepassword.vue')
const Frame = () => import('@/page/frame/extra.vue')
const FrameIndex = () => import('@/page/frame/index.vue')
const Preview = () => import('@/page/report/reportPreview')// 报告预览
const autoLogin = () => import('@/page/autoLogin')

import Product from './modules/product'

Vue.use(Router)

export const constantRouterMap = [
  { path: '/', redirect: '/home' },
  { path: '/login', name: 'login', component: Login },
  { path: '/report/platformReport/preview', name: 'preview', component: Preview },
  { path: '/report/platform/preview', name: 'preview', component: Preview },
  { path: '/report/project/preview', name: 'preview', component: Preview },

  // chillum 20200414
  { path: '/report/preview', name: 'reportPreview', component: () => import('@/page/onlineReport/preview') },
  { path: '/report/redirect/:path*', name: 'redirect', component: () => import('@/page/onlineReport/redirect') },
  {
    path: '',
    component: Layout,
    children: [
      { path: '/home', name: 'home', component: Home },
      { path: '/notice', name: 'notice', component: Notice },
      { path: '/base_info', name: 'base_info', component: BaseInfo },
      { path: '/feedback_results', name: 'feedback_results', component: FeedbackResults },
      { path: '/change_password', name: 'change_password', component: ChangePassWord },
      // frame的模块忽略动态加载路由
      { path: '/frame', name: 'frame', component: Frame },
      { path: '/reports-public/*', component: FrameIndex, meta: { context: '/report/index.html' }},
      { path: '/reports-product/*', component: FrameIndex, meta: { context: '/report/index.html' }},
      // 404页面
      { path: '/404', name: '404', component: Error404 }
    ]
  },
  { path: '/autoLogin', name: 'autoLogin', component: autoLogin }
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  Product
]

export const suffixRouterMap = [
  // { path: '*', redirect: '/home' }
]



// WEBPACK FOOTER //
// ./src/router/index.js